let config = {
  baseURL: "https://manasa.easytech-sotfware.com/",
  // baseURL: "https://test.easytech-sotfware.com/",
};

export default config;
